import { render } from "./DynamicFile.vue?vue&type=template&id=747c6075&scoped=true&ts=true"
import script from "./DynamicFile.vue?vue&type=script&lang=ts"
export * from "./DynamicFile.vue?vue&type=script&lang=ts"

import "./DynamicFile.vue?vue&type=style&index=0&id=747c6075&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747c6075"]])

export default __exports__